import Color from 'color';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

const ProgressBar = ({ percentWidth }) => (
  <StyledProgressBarWrapper data-testid="progress-bar-grey-wrapper">
    <StyledProgressBar
      data-testid="progress-bar-primary"
      $percentWidth={percentWidth}
    />
  </StyledProgressBarWrapper>
);

ProgressBar.propTypes = {
  percentWidth: PropTypes.number.isRequired,
};

export default ProgressBar;

const StyledProgressBarWrapper = styled(Box).attrs(() => ({
  height: '9px',
  width: '100%',
}))`
  border-radius: 5px;
  clip-path: inset(0 0 0 0 round 5px);
  background-color: ${({ theme }) =>
    Color(theme.colors.primary).alpha(0.6).string()};
`;

const StyledProgressBar = styled(Box).attrs(({ $percentWidth }) => ({
  bg: 'primary',
  height: '100%',
  width: `${$percentWidth}%`,
}))`
  border-radius: 5px;
`;
